import Component from "@glimmer/component"
import type { FiscalGroup } from "@shared/models/fiscal-group"
import type { GroupMembership } from "@shared/models/group"
import { isUpgradedMembership } from "cc-frontend/utils/group"

interface Signature {
  Args: {
    teacherMemberships: GroupMembership[]
    fiscalGroup: FiscalGroup | null
  }
}

export default class GroupMembersTableUpgradedHeader extends Component<Signature> {
  get count(): number {
    return this.args.teacherMemberships.filter((membership) =>
      isUpgradedMembership(this.args.fiscalGroup, membership)
    ).length
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Group::MembersTable::Headers::Upgraded": typeof GroupMembersTableUpgradedHeader
  }
}
